module.exports = __webpack_public_path__ + "img/103.1.df368989.jpg";